import { config } from '../env';
import { Delete, get, patch, post } from './helpers/http-handler';

// Compliance
export const getDashboardActivity = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/activity?${queryRequest}`,
  );

export const getDashboardState = (queryRequest: string) =>
  get(`${config.API_URL}/compliance-task/view/dashboard/state?${queryRequest}`);

export const getDashboardStateMonth = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/state/month?${queryRequest}`,
  );
export const getDashboardOverallScore = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/overall-score?${queryRequest}`,
  );
export const getDashboardNatureScore = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/nature-score?${queryRequest}`,
  );
export const getDashboardLocation = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/location?${queryRequest}`,
  );
export const getDashboardCategory = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/category?${queryRequest}`,
  );
export const getDashboardFunctions = (queryRequest: string) =>
  get(
    `${config.API_URL}/compliance-task/view/dashboard/function?${queryRequest}`,
  );

// license

export const getDashboardLicenceActivity = (queryRequest: string) =>
  get(`${config.API_URL}/license-task/view/dashboard/activity?${queryRequest}`);

export const getDashboardLicenceLocations = (queryRequest: string) =>
  get(`${config.API_URL}/license-task/view/dashboard/location?${queryRequest}`);

export const getDashboardLicenceLocationLicenceType = (queryRequest: string) =>
  get(
    `${config.API_URL}/license-task/view/dashboard/license-type?${queryRequest}`,
  );

export const getDashboardLicenceCurrentStats = (queryRequest: string) =>
  get(
    `${config.API_URL}/license-task/view/dashboard/current-license-stats?${queryRequest}`,
  );

export const getDashboardLicenceDailyCount = (queryRequest: string) =>
  get(
    `${config.API_URL}/license-task/view/dashboard/daily-count?${queryRequest}`,
  );

export const getDashboardSelfCompliance = (queryRequest: string) =>
  get(`${config.API_URL}/self-compliance-task/view/dashboard?${queryRequest}`);

export const getDashboardSelfActivity = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/view/dashboard/self-activity?${queryRequest}`,
  );

export const getDashboardSelfActivityByLevel = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/view/new-dashboard/self-activity?${queryRequest}`,
  );

//user entity

export const getDashboardSelfComplianceUserEntity = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/view/dashboard/overall?${queryRequest}`,
  );

export const getDashboardSelfComplianceUserEntityByLevel = (
  queryRequest: string,
) =>
  get(
    `${config.API_URL}/self-compliance-task/view/new-dashboard/overall?${queryRequest}`,
  );

export const refreshComplaince = () =>
  get(`${config.API_URL}/self-compliance-task/refresh/dashboard`);

export const getDashboardSelfComplianceUserEntityData = (
  queryRequest: string,
  is_list: boolean,
  is_graph: boolean,
) =>
  get(
    `${config.API_URL}/self-compliance-task/view/dashboard/by-entity?${queryRequest}&is_list=${is_list}&graph=${is_graph}`,
  );

export const getDashboardSelfComplianceUserEntityDataWithoutGraph = (
  queryRequest: string,
  is_list: boolean,
) =>
  get(
    `${config.API_URL}/self-compliance-task/view/dashboard/by-entity?${queryRequest}&is_list=${is_list}`,
  );

// export const getDashboardSelfComplianceUserEntityData = (
//   queryRequest: string,
// ) =>
//   get(
//     `${config.API_URL}/self-compliance-task/view/dashboard/by-entity?${queryRequest}`
//   );

export const getDashboardSelfComplianceUserEntityDataByLevel = (
  queryRequest: string,
  is_list: boolean,
) =>
  get(
    `${config.API_URL}/self-compliance-task/view/new-dashboard/by-entity?${queryRequest}&is_list=${is_list}`,
  );

//export

export const exportSelfCompliance = (payload: object) =>
  post(
    `${config.API_URL}/reports/export-self-compliance-task-by-entity`,
    payload,
  );

export const exportAuditUploadLocation = (payload: object) =>
  post(`${config.API_URL}/reports/export-audit-upload-by-location`, payload);

export const exportAuditUploadVendor = (payload: object) =>
  post(`${config.API_URL}/reports/export-audit-upload-by-vendor`, payload);

//user entity

export const getListCertificates = (queryRequest: string) =>
  get(`${config.API_URL}/certificate?${queryRequest}`);

export const addCertificate = (payload: object) =>
  post(`${config.API_URL}/certificate`, payload);

export const getComplianceListCertificates = (queryRequest: string) =>
  get(`${config.API_URL}/certificate/compliance?${queryRequest}`);

export const addComplianceCertificate = (payload: object) =>
  post(`${config.API_URL}/certificate/compliance`, payload);

//Dashboard Compliance
export const getVendorDashboardClient = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/vendor-dashboard/client?${queryRequest}`,
  );

export const getVendorDashboardClientReleaseDate = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/vendor-dashboard/client/release-date?${queryRequest}`,
  );

export const getVendorDashboardClientReleaseCycle = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/vendor-dashboard/client/release-date/cycle?${queryRequest}`,
  );

export const getVendorDashboardClientReleaseDateCycleDetails = (
  queryRequest: string,
) =>
  get(
    `${config.API_URL}/vendor-checkpoint/vendor-dashboard/client/release-date/cycle/details?${queryRequest}`,
  );

export const refreshVendorComplaince = () =>
  get(`${config.API_URL}/vendor-checkpoint/refresh/materilze/view`);

// License Valid
export const getDashboardLicenceValid = (queryRequest: string) =>
  get(
    `${config.API_URL}/license-task/view/dashboard/valid-license-stats?${queryRequest}`,
  );

export const getDashboardLicenceValidFunctions = (locationId: string) =>
  get(
    `${config.API_URL}/license-task/valid-license-types/location/${locationId}`,
  );

// Renewals
export const getDashboardLicenceRenewals = (queryRequest: string) =>
  get(
    `${config.API_URL}/license-task/view/dashboard/renewal-license-stats?${queryRequest}`,
  );

export const getDashboardLicenceRenewalsFunctions = (
  locationId: string,
  queryRequest: string,
) =>
  get(
    `${config.API_URL}/license-task/license-types/location/${locationId}?${queryRequest}`,
  );
